:host {
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  display: block;
}

:host *,
label,
select {
  user-select: none;
  box-sizing: border-box;
}

select::-webkit-outer-spin-button,
select::-webkit-inner-spin-button {
  appearance: none;
}

.dropdown {
  --_dropdown-select-cursor: pointer;
}

.dropdown-select-wrapper {
  position: relative;
}

.dropdown-select {
  cursor: var(--_dropdown-select-cursor);
  outline: none;
  width: 100%;
  appearance: none;
}

.dropdown-select:focus {
  --_dropdown-select-border-color: var(--_dropdown-select-focused-border-color);
}

.dropdown-label {
  position: absolute;
  top: 6px;
  opacity: 0.7;
}

.dropdown-icon {
  height: 24px;
  width: 24px;
  transform: rotate(90deg) translateX(-50%);
  position: absolute;
  top: 50%;
  bottom: 50%;
  pointer-events: none;
}

.dropdown-messages {
  opacity: 0.7;
}

.dropdown--disabled {
  --_dropdown-select-cursor: default;

  opacity: 0.5;
}
:host *,
label,
select {
  font-weight: var(--ui-font-weight-regular);
  margin: 0;
}

.dropdown {
  --_dropdown-select-padding: var(--ui-space-lg) var(--ui-space-md) var(--ui-space-xs);
  --_dropdown-select-border-color: var(--ui-color-gray-4);
  --_dropdown-select-focused-border-color: var(--ui-color-secondary);
  --_dropdown-messages-color: var(--ui-color-text);
}

.dropdown-select {
  padding: var(--_dropdown-select-padding);
  color: var(--ui-color-text);
  font-size: var(--ui-font-size-base);
  line-height: var(--ui-line-height-base);
  background-color: var(--ui-color-gray-1);
  border-radius: var(--ui-border-radius-md);
  border: 1px solid var(--_dropdown-select-border-color);
}

.dropdown-select:focus {
  --_dropdown-select-border-color: var(--_dropdown-select-focused-border-color);
}

.dropdown-label {
  left: var(--ui-space-md);
  font-size: var(--ui-font-size-xs);
  line-height: var(--ui-line-height-base);
}

.dropdown-icon {
  right: var(--ui-space-sm);
}

.dropdown-messages {
  margin: var(--ui-space-xs);
  font-size: var(--ui-font-size-xs);
  font-weight: var(--ui-font-weight-regular);
  line-height: var(--ui-line-height-base);
  color: var(--_dropdown-messages-color);
}

.dropdown--has-error {
  --_dropdown-select-border-color: var(--ui-color-error);
  --_dropdown-select-focused-border-color: var(--ui-color-error);
  --_dropdown-messages-color: var(--ui-color-error);
}

.dropdown--no-label {
  --_dropdown-select-padding: var(--ui-space-md);
}
